import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { processSteps } from '../../data/process';
import { SectionHeading } from '../SectionHeading';
export function ProcessSection() {
  const {
    t
  } = useLanguage();
  return <section className="bg-navy-deep" aria-labelledby="process-heading" data-id="element-164" data-mp="bt1n05xvg26o">
      <div className="mx-auto max-w-7xl px-6 py-16 sm:py-24" data-id="element-165" data-mp="7s811i3zoxgf">
        <SectionHeading id="process-heading" tone="dark" eyebrow={t({
        en: 'How it works',
        es: 'Cómo funciona'
      })} title={t({
        en: 'From first call to final walkthrough',
        es: 'De la primera llamada al recorrido final'
      })} description={t({
        en: 'Six steps, every job, no exceptions. You always know what happens next and who to call.',
        es: 'Seis pasos, en cada trabajo, sin excepciones. Siempre sabes qué sigue y a quién llamar.'
      })} data-id="element-166" data-mp="2u6jj1m7p672" />

        <ol className="mt-12 grid gap-x-10 gap-y-10 md:grid-cols-2 lg:grid-cols-3" data-id="element-167" data-mp="3baru2muhs7ca">
          {processSteps.map((step, index) => <li key={step.title.en} className="relative border-t border-white/15 pt-6" data-id="element-168" data-mp="3t3voef25oghb" data-mpi={index}>
              <div className="flex items-baseline gap-3" data-id="element-169" data-mp="3t5qcg28q4opm">
                <span className="font-display text-3xl text-gold" data-id="element-170" data-mp="3fds59wykp2w3">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <h3 className="font-display text-xl text-white" data-id="element-171" data-mp="ay977u980aas">{t(step.title)}</h3>
              </div>
              <p className="mt-3 leading-relaxed text-navy-100/85" data-id="element-172" data-mp="fxddod4rftxf">{t(step.description)}</p>
              <step.icon className="mt-5 h-6 w-6 text-gold/70" aria-hidden="true" data-id="element-173" data-mp="fuzk68pqaprz" />
            </li>)}
        </ol>
      </div>
    </section>;
}